import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { LoanApplication, DiscountType } from 'generated/graphql';
import { ISimulationResult } from 'interfaces/interfaces';
import { recalculateSimulationResult } from 'utils/simulation-utils';
import { formatMoney } from 'utils/utils';
import { getProductBrand, brandArticle } from 'constants/brand-constants';
import editIcon from 'assets/img/editar@3x.png';

interface ILoanInfoProps {
    loanApplication: LoanApplication;
    className?: string;
    canEdit: boolean;
    discounts?: DiscountType[];
    onClick?: () => any;
}

const LoanInfo: React.FC<ILoanInfoProps> = (props): JSX.Element => {

    const { loanApplication, className, onClick, canEdit, discounts } = props;
    const { acceptedProposal } = loanApplication && loanApplication;
    const insurance = loanApplication?.tracking?.insuranceOptIn?.accepted ?? false;
    const [simulation, setSimulation] = useState<ISimulationResult>();

    const brand = getProductBrand(loanApplication.product.bizId);
    const { na_no } = brandArticle(brand);

    useEffect(() => {
        setSimulation(recalculateSimulationResult(loanApplication, discounts, insurance, loanApplication.product.bizId))

    }, [discounts]);

    return (
        <div className={`grid-loan-confirmation highlight-card ${className}`} onClick={onClick}>
            <div className="grid-loan-summary">
                <h3 className="mb-4 d-inline-block">
                    seu empréstimo {na_no} {brand.branchShortName}
                </h3>

                {canEdit &&
                    <div className="d-inline-block float-right primary-text position-relative mobile-only edit-button">
                        <a className="mr-2 font-weight-bold">
                            editar
                        </a>
                        <img src={editIcon} className="edit-icon" />
                    </div>
                }

                <table className="table table-borderless table-sm">
                    <tbody>
                        <tr>
                            <td>
                                Empréstimo
                            </td>
                            <td className="highlight-text font-weight-bold">
                                R$ {formatMoney(acceptedProposal.amount)}
                            </td>
                        </tr>
                        <tr>
                            {acceptedProposal &&
                                <td className="pt-4">
                                    Taxas
                                    <p className="secondary-text">
                                        juros de {acceptedProposal.interestRate}% ao mês, IOF e TC
                                    </p>
                                </td>
                            }
                            {simulation &&
                                <td className="pt-4">
                                    R$ {formatMoney(simulation.feesAmount)}
                                </td>
                            }
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="grid-payment-summary">
                <h3 className="mb-4 d-inline-block">
                    configurações do pagamento
                </h3>

                {canEdit &&
                    <div className="d-inline-block float-right primary-text position-relative desktop-only edit-button">
                        <a className="mr-2 font-weight-bold">
                            editar
                        </a>
                        <img src={editIcon} className="edit-icon" />
                    </div>
                }

                <table className="table table-borderless table-sm">
                    <tbody>
                        <tr>
                            <td>
                                {acceptedProposal.tenure} Parcelas
                            </td>
                            {simulation &&
                                <td>
                                    R$ {formatMoney(simulation.pmt)}
                                </td>
                            }
                        </tr>
                        <tr>
                            <td className="pt-4">
                                Vencimento mensal
                                <p className="secondary-text">
                                    boletos gerados mensalmente
                                </p>
                            </td>
                            <td className="pt-4">
                                {moment(acceptedProposal.paymentDay as Date).format('[Dia] DD')}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default LoanInfo;
